import axios from 'axios';
import { API_BASE_URL } from '@/config/api';

const ONBOARDING_URL = `${API_BASE_URL}/onboarding/restaurant`;

export async function createOrResumeRestaurantOnboarding(clientRequestId) {
  const { data } = await axios.post(
    ONBOARDING_URL,
    { client_request_id: clientRequestId },
    { withCredentials: true }
  );
  return data;
}

export async function getRestaurantOnboardingSession(sessionId) {
  const { data } = await axios.get(
    `${ONBOARDING_URL}/${encodeURIComponent(sessionId)}`,
    { withCredentials: true }
  );
  return data;
}

export async function updateRestaurantOnboardingSession(sessionId, revision, restaurant) {
  const { data } = await axios.patch(
    `${ONBOARDING_URL}/${encodeURIComponent(sessionId)}`,
    {
      revision,
      current_step: 'restaurant',
      restaurant,
    },
    { withCredentials: true }
  );
  return data;
}
export async function completeRestaurantOnboarding(sessionId, revision) {
  const { data } = await axios.post(
    `${ONBOARDING_URL}/${encodeURIComponent(sessionId)}/complete`,
    { revision },
    { withCredentials: true }
  );
  return data;
}
